module.exports = __webpack_public_path__ + "static/zoom-button-a42bbfbfbee1c90bed89978e8976f112.png";